import { useReduxState } from 'hooks';
import { breakpoints } from 'styles';
import {
  ProfileAmbitions,
  ProfileCompetencies,
  ProfileSummaryCompetencies,
  ProfileSummaryCompetencyMapping,
  ProfileSummaryCompetencyProfiles,
  ProfileSummaryGroups,
  ProfileSummaryInfo,
  ProfileSummaryTimeline,
  ProfileSupervisors,
  ProfileSummaryUpcoming
} from '.';

interface Props {
  isUserPage?: boolean;
}

const ProfileSummary = ({ isUserPage }: Props) => {
  const {
    pageState: { user },
    serverConfig
  } = useReduxState();

  return (
    <div className="summary">
      <div className="main">
        <ProfileSummaryCompetencyMapping />

        <ProfileSummaryInfo isUserPage={isUserPage} targetUser={user} />

        {!user?.roles?.includes('guest') ? (
          <>
            {serverConfig.featureFlags.enableCompetencyImprovements ? (
              <div className="section">
                <ProfileSummaryCompetencyProfiles isUserPage={isUserPage} />
              </div>
            ) : null}

            <div className="section">
              {serverConfig.featureFlags.enableCompetencyImprovements ? (
                <ProfileSummaryCompetencies isUserPage={isUserPage} />
              ) : (
                <ProfileCompetencies
                  apiUrl="/admin/users"
                  isUserPage={isUserPage}
                  targetUser={user}
                />
              )}
            </div>

            <div className="section">
              <ProfileAmbitions isUserPage={isUserPage} targetUser={user} />
            </div>

            <div className="section">
              <ProfileSupervisors
                isUserPage={isUserPage}
                targetUserId={user.id}
              />
            </div>

            <div className="section">
              <ProfileSummaryGroups targetUserId={user.id} />
            </div>
          </>
        ) : null}
      </div>

      {!serverConfig.platformCompetenciesOnly && (
        <div className="side">
          <ProfileSummaryTimeline
            isUserPage={isUserPage}
            targetUserId={user?.id}
          />

          <ProfileSummaryUpcoming
            isUserPage={isUserPage}
            targetUserId={user?.id}
          />
        </div>
      )}

      <style jsx>{`
        .section {
          margin-top: 20px;
        }
        .section:not(:first-child) {
          margin-top: 30px;
        }
        .summary {
          align-items: flex-start;
          display: flex;
          flex-direction: column;
          gap: 30px;
        }
        .main {
          flex-grow: 1;
          min-width: 0;
        }
        .side {
          display: flex;
          flex-direction: column;
          flex-grow: 0;
          flex-shrink: 0;
          gap: 30px;
          width: 100%;
        }
        @media (min-width: ${breakpoints.large}px) {
          .summary {
            flex-direction: row;
          }
          .side {
            width: 460px;
          }
        }
      `}</style>
    </div>
  );
};

export default ProfileSummary;
